module.exports = __webpack_public_path__ + "static/media/pontoshistoricos.29968168.svg";